import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  ModalTitle,
  ModalFooter,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { MANAGER, TEAM_LEADER } from "../../store/actions/users/usersActions";
import { Cache } from "aws-amplify";

import {
  deleteDailyTaskAssignment,
  deleteTaskRow,
  fetchDailyTask,
  handleDailyTaskChange,
  updateDailyTaskActivity,
  updateDailyTask,
  updateDailyTaskRemark,
} from "../../store/actions/timesheet/taskActions";
import "../../css/dailytask.css";
import { togglePrompt } from "../../store/actions/commonActions";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import DailyTaskDetailsById from "./DailyTaskDetailsById";

class DailyTaskForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      taskStatus: props.task.action ?? "Pending",
      task: props.task,
      entry_id: props.entry_id,
      readOnly: false,
      isDeletable: true,
      disableConfirm: true,
      confirmAction: "Pending",
      sla: props.task.sla,
      actual_transaction: props.task.actual_transaction,
      expected_transaction: props.task.expected_transaction,
      modalType: "",
      selectedProject: {
        value: props.task.project_id,
        label: props.task.project_name,
      },
      selectedTask: { value: props.task.task_id, label: props.task.task_name },
      show: false,
      reason: "",
      remarks: "",
      user_id: props.user_id,
    };
  }

  handleQuickActions = async (action) => {
    if (action === "On Hold") {
      this.state.show = true;
      this.state.confirmAction = action;
      this.state.modalType = action;
      // this.props.togglePrompt(true);
    } else {
      await this.props.updateDailyTaskActivity(
        this.props.entry_id,
        action,
        null,
        null,
        this.props.id,
        this.props.user_id
      );
    }

    this.setState({ taskStatus: action === "Resume" ? "On Going" : action });
  };

  handleProjectTask = () => {
    const project_id = this.state.selectedProject.value;
    const task_id = this.state.selectedTask.value;

    this.props.updateDailyTask(
      this.props.entry_id,
      project_id,
      task_id,
      this.props.id
    );
  };

  handleDeleteTaskAssignment = () => {
    this.setState({ show: true, modalType: "Delete", actionType: "Delete" });
    this.state.modalType = "Delete";

    // this.props.deleteDailyTaskAssignment(this.state.entry_id, this.props.id);
  };

  showRemarksModal = () => {
    this.setState({ show: true, modalType: "Remarks", actionType: "Remarks" });
  };

  // showConfirmationModal = () => {
  //   this.setState({ show: true, modalType: "Restart" });
  // };

  showConfirmationModal = (actionType) => {
    this.setState({ show: true, modalType: "Restart", actionType: actionType });
  };

  renderModal = () => {
    const reasonId = "reason";

    let modalTitle = "";
    let modalBody = "";
    let actionType = this.state.actionType;
    let onHideFunction = {};
    let onClickCancel = {};
    let onClickConfirm = {};
    let specialForm = "";
    const confirmButtonText = "Yes, Confirm";
    const cancelButtonText = "Cancel";
    const spinner = '<span class="spinner-border spinner-border-sm"></span>'; //html of react spinner\
    if (this.state.showConfirmationModal) {
      modalTitle = "Restart Task";
    } else {
      modalTitle = "Fail Task";
    }
    modalBody = "Do you want to  this task?";

    const handleReason = (e) => {
      this.state.reason = e.target.value;
      const minRemarkLength = 1;
      if (
        this.state.modalType === "On Hold" &&
        this.state.reason &&
        this.state.reason.length >= minRemarkLength
      ) {
        this.setState({ disableConfirm: false });
      } else {
        this.setState({ disableConfirm: true });
      }
    };
    const handleRemarks = (e) => {
      this.state.remarks = e.target.value;
      const minRemarkLength = 1;
      const maxLength = 500;
      if (
        e.target.value.length >= minRemarkLength &&
        e.target.value.length <= maxLength
      ) {
        this.setState({ disableConfirm: false });
      } else {
        this.setState({ disableConfirm: true });
      }
      if (e.target.value.length <= maxLength) {
        this.setState({ remarks: e.target.value });
      } else {
        e.preventDefault();
      }
    };

    switch (this.state.modalType) {
      case "On Hold":
        modalTitle = "Pause Reason";

        modalBody = "State reason for pausing";

        onClickConfirm = async () => {
          await this.props.updateDailyTaskActivity(
            this.props.entry_id,
            this.state.confirmAction,
            this.state.reason,
            null,
            this.props.id,
            this.props.user_id
          );

          this.state.show = false;
        };

        specialForm = (
          <>
            <Row className="mt-3">
              <Col>
                <Form>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      rows="3"
                      id={reasonId}
                      onChange={handleReason}
                      maxLength={500}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </>
        );
        break;

      case "Delete":
        this.state.disableConfirm = false;
        modalTitle = "Delete Entry";

        modalBody = "Are you sure you want to delete this task?";

        onClickConfirm = async () => {
          await this.props.deleteDailyTaskAssignment(
            this.state.entry_id,
            this.props.id,
            this.props.user_id
          );

          this.state.show = false;
        };

        break;

      case "Remarks":
        modalTitle = "Remarks";

        onClickConfirm = async () => {
          await this.props.updateDailyTaskRemark(
            this.props.entry_id,
            this.state.remarks,
            this.props.id,
            this.props.user_id
          );

          this.state.show = false;
        };

        modalBody = (
          <Form.Group>
            <Form.Control
              as="textarea"
              rows="3"
              // value={this.state.reason}
              // value={this.props.remarks}
              placeholder=""
              onChange={handleRemarks}
              maxLength={500}
            />
            <div>Maximum of only 500 characters.</div>
          </Form.Group>
        );

        break;

      default:
    }

    switch (actionType) {
      case "Restart":
        this.state.disableConfirm = false;
        modalTitle = "Restart Task";
        modalBody = "Do you want to restart this task?";
        onClickConfirm = async () => {
          await this.props.updateDailyTaskActivity(
            this.props.entry_id,
            "Restart",
            null,
            null,
            this.props.id,
            this.props.user_id
          );

          this.state.taskStatus = "Pending";
          this.state.show = false;
        };
        break;
      case "Fail":
        this.state.disableConfirm = false;
        modalTitle = "Fail Task";
        modalBody = "Do you want to fail this task?";
        onClickConfirm = async () => {
          await this.props.updateDailyTaskActivity(
            this.props.entry_id,
            "Failed",
            null,
            null,
            this.props.id,
            this.props.user_id
          );

          this.state.taskStatus = "Failed";
          this.state.show = false;
        };
        break;

      //delegate to braden
      case "End":
        this.state.disableConfirm = false;

        modalTitle = "End Task";
        modalBody = "Do you want to end this task?";

        onClickConfirm = async () => {
          await this.props.updateDailyTaskActivity(
            this.props.entry_id,
            "Completed",
            null, // end reason
            null,
            this.props.id,
            this.props.user_id
          );

          this.state.taskStatus = "Completed";
          this.state.show = false;
        };
        break;
      default:
        break;
    }

    onHideFunction = () => {
      this.setState({ show: false, confirmAction: "", modalType: "" });
      if (this.state.modalType === "On Hold") {
        this.setState({ taskStatus: "On Going" });
      }
    };

    onClickCancel = () => {
      this.setState({ show: false, confirmAction: "", modalType: "" });
      if (this.state.modalType === "On Hold") {
        this.setState({ taskStatus: "On Going" });
      }
    };

    return (
      <Modal
        show={this.state.show}
        onHide={() => {
          onHideFunction();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title> {modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalBody}
          {specialForm ?? ""}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="nopeCancel"
            size="sm"
            variant="secondary"
            className="float-left"
            onClick={() => {
              onClickCancel();
            }}
          >
            {cancelButtonText}
          </Button>
          <Button
            id="yesConfirm"
            size="sm"
            variant="primary"
            disabled={this.state.disableConfirm}
            onClick={() => {
              const confirmButton = document.getElementById("yesConfirm");
              confirmButton.disabled = true;
              confirmButton.innerHTML = spinner;

              const cancelButton = document.getElementById("nopeCancel");
              cancelButton.disabled = true;
              cancelButton.innerHTML = spinner;

              onClickConfirm();
            }}
          >
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  renderSampleTask = () => {
    let task_status = "Pending";
    let projectOptions = this.props.dailyTasks.projectOptions;
    let taskOptions = this.props.dailyTasks.taskOptions;
    this.state.readOnly =
      this.state.selectedProject.value !== "" &&
      this.state.selectedTask.value !== ""
        ? true
        : false;

    const roleId = Cache.getItem("roleId");

    return (
      <>
        {this.state.show ? this.renderModal() : <></>}
        <tr key={1}>
          {/* select project */}
          <td colSpan={2}>
            {/* dev notes: taken from timesheetform.js that renders project list */}
            <Select
              className="dailyTaskSelect"
              classNamePrefix="dailyTaskSelect"
              size="sm"
              value={this.state.selectedProject}
              isDisabled={this.state.readOnly || !this.props.isCurrentDate}
              onChange={(selectedOption) => {
                this.state.selectedProject = selectedOption.value;
                this.props.handleDailyTaskChange(
                  null,
                  this.props.entry_id,
                  null,
                  {
                    id: "project_id",
                    value: selectedOption.value,
                  }
                );
                this.state.selectedProject = selectedOption;
              }}
              options={projectOptions}
            />
          </td>

          {/* select task */}
          <td colSpan={2}>
            {/* dev notes: taken from timesheetform.js that renders task list */}
            <Select
              className="dailyTaskSelect"
              classNamePrefix="dailyTaskSelect"
              size="sm"
              value={this.state.selectedTask}
              onChange={(selectedOption) => {
                this.props.handleDailyTaskChange(
                  null,
                  this.props.entry_id,
                  null,
                  {
                    id: "task_id",
                    value: selectedOption.value,
                  }
                );
                this.state.selectedTask = selectedOption;

                this.handleProjectTask();
              }}
              isDisabled={
                this.state.selectedTask === ""
                  ? true
                  : this.state.readOnly || !this.props.isCurrentDate
              }
              options={
                this.state.selectedProject !== ""
                  ? taskOptions[this.state.selectedProject.value]
                  : null
              }
            />
          </td>

          {/* Actual/Expected Transactions */}
          <td colSpan={1}>
            <div className="d-flex justify-content-center">
              {this.props.task.actual_transaction}/
              {this.props.task.expected_transaction}
            </div>
          </td>

          {/* Status */}
          <td colSpan={2} className="align-center">
            {this.state.taskStatus === "Pending" ? (
              <strong style={{ color: "#ffc107" }}>Pending</strong>
            ) : this.state.taskStatus === "On Going" ? (
              <strong style={{ color: "#17a2b8" }}>On Going</strong>
            ) : this.state.taskStatus === "On Hold" ? (
              <strong style={{ color: "#6c757d" }}>On Hold</strong>
            ) : this.state.taskStatus === "Completed" ? (
              <strong style={{ color: "#28a745" }}>Completed</strong>
            ) : this.state.taskStatus === "Failed" ? (
              <strong style={{ color: "#CC3333" }}>Failed</strong>
            ) : null}
          </td>

          {/* Quick Actions */}
          <td colSpan={2} className="align-center">
            {roleId !== TEAM_LEADER && roleId !== MANAGER ? (
              this.state.taskStatus === "Pending" ? (
                <Button
                  size="sm"
                  onClick={() => {
                    this.handleQuickActions("On Going");
                    this.setState({ isDeletable: false });
                  }}
                  disabled={!this.state.readOnly || !this.props.isCurrentDate}
                >
                  Start
                </Button>
              ) : this.state.taskStatus === "On Going" ? (
                <>
                  <Button
                    className="mx-1"
                    size="sm"
                    variant="secondary"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => {
                      this.handleQuickActions("On Hold");
                    }}
                  >
                    Pause
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => this.handleQuickActions("Completed")}
                  >
                    Stop
                  </Button>
                </>
              ) : this.state.taskStatus === "On Hold" ? (
                <>
                  <Button
                    size="sm"
                    variant="info"
                    disabled={
                      !this.props.isCurrentDate
                      // || this.props.task.for_approval === 1 DISABLES BUTTON WHEN NEEDS APPROVAL
                    }
                    onClick={() => {
                      this.handleQuickActions("Resume");
                    }}
                  >
                    Resume
                  </Button>
                  <Button
                    className="mx-1"
                    size="sm"
                    variant="danger"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => this.handleQuickActions("Completed")}
                  >
                    Stop
                  </Button>
                </>
              ) : this.state.taskStatus === "Completed" ? (
                <Button size="sm" variant="success" disabled>
                  Completed
                </Button>
              ) : this.state.taskStatus === "Failed" ? (
                <Button size="sm" variant="danger" disabled>
                  Failed
                </Button>
              ) : null
            ) : this.state.taskStatus === "Pending" ? (
              <Button
                size="sm"
                variant="warning"
                onClick={() => this.showConfirmationModal("Fail")}
                // onClick={() => this.handleQuickActions("Completed")}
              >
                Fail
              </Button>
            ) : this.state.taskStatus === "On Going" ? (
              <>
                {this.props.isCurrentDate ? (
                  <Button
                    className="m-1"
                    size="sm"
                    variant="info"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => {
                      this.showConfirmationModal("Restart");
                    }}
                  >
                    Restart
                  </Button>
                ) : (
                  <></>
                )}
                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => this.showConfirmationModal("Fail")}
                  // onClick={() => this.handleQuickActions("Completed")}
                >
                  Fail
                </Button>
                <Button
                  className="mx-1"
                  size="sm"
                  variant="danger"
                  onClick={() => this.showConfirmationModal("End")}
                  // onClick={() => this.handleQuickActions("Completed")}
                >
                  End
                </Button>
              </>
            ) : this.state.taskStatus === "On Hold" ? (
              <>
                {this.props.isCurrentDate ? (
                  <Button
                    className="m-1"
                    size="sm"
                    variant="info"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => this.showConfirmationModal("Restart")}
                    // onClick={() => {
                    //   this.handleQuickActions("On Hold");
                    // }}
                  >
                    Restart
                  </Button>
                ) : (
                  <></>
                )}

                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => this.showConfirmationModal("Fail")}
                  // onClick={() => this.handleQuickActions("Completed")}
                >
                  Fail
                </Button>
                <Button
                  className="mx-1"
                  size="sm"
                  variant="danger"
                  onClick={() => this.showConfirmationModal("End")}
                  // onClick={() => this.handleQuickActions("Completed")}
                >
                  End
                </Button>
              </>
            ) : this.state.taskStatus === "Completed" ? (
              <Button size="sm" variant="success" disabled>
                Completed
              </Button>
            ) : this.state.taskStatus === "Failed" ? (
              <>
                {this.props.isCurrentDate ? (
                  <Button
                    className="mx-1"
                    size="sm"
                    variant="info"
                    disabled={!this.props.isCurrentDate}
                    onClick={() => {
                      this.showConfirmationModal("Restart");
                    }}
                  >
                    Restart
                  </Button>
                ) : (
                  <>
                    {" "}
                    <Button size="sm" variant="danger" disabled>
                      Failed
                    </Button>
                  </>
                )}
              </>
            ) : null}
          </td>

          {/* Start Time */}
          <td colSpan={1}>
            <div className="d-flex justify-content-center">
              {this.props.task.start_time !== ""
                ? this.props.task.start_time
                : "00:00:00"}
            </div>
          </td>

          {/* End Time */}
          <td colSpan={1}>
            <div className="d-flex justify-content-center">
              {this.props.task.end_time !== ""
                ? this.props.task.end_time
                : "00:00:00"}
            </div>
          </td>

          {/* Actual Time Time */}
          <td colSpan={1}>
            <div className="d-flex justify-content-center justify-center h-auto">
              {this.props.task.actual_time !== ""
                ? this.props.task.actual_time
                : "00:00:00"}
            </div>
          </td>
          {/* Action */}
          <td colSpan={2}>
            <div className="d-flex justify-content-center justify-center h-auto align-items-center ">
              <Button
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  const id = this.props.entry_id;
                  const urlParams = new URLSearchParams(
                    this.props.location.search
                  );
                  const user_id = urlParams.get("user_id");
                  const current_user_id = Cache.getItem("userId");
                  this.props.history.push(
                    `/dailytasks/details?id=${id}&user_id=${
                      user_id ?? current_user_id
                    }`
                  );
                }}
                id="view-task"
                className="mx-1"
                disabled={this.state.taskStatus === "Pending"}
              >
                View
              </Button>
              {this.props.isCurrentDate ? (
                <Button
                  size="sm"
                  id="view-task"
                  className="mx-1"
                  onClick={this.showRemarksModal}
                  disabled={this.state.taskStatus === "Pending"}
                >
                  Remarks
                </Button>
              ) : (
                <></>
              )}

              {/* onClick={this.props.deleteTaskRow(this.props.entry_id)} */}
              {this.state.taskStatus === "Pending" ? (
                <FontAwesomeIcon
                  icon={faTrash}
                  onClick={this.handleDeleteTaskAssignment}
                  id="view-task"
                  className="mx-1 hover-pointer"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faTrash}
                  id="view-task"
                  style={{ color: "#dedede" }}
                  className="mx-1"
                />
              )}
            </div>
          </td>
        </tr>
      </>
    );
  };

  render() {
    let project = {};
    let projectId = "";
    let taskId = "";

    return this.renderSampleTask();
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  dailyTasks: state.dailyTasks,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDailyTaskAssignment: (...args) =>
      dispatch(deleteDailyTaskAssignment(...args)),
    fetchDailyTask: (...args) => dispatch(fetchDailyTask(...args)),
    handleDailyTaskChange: (...args) =>
      dispatch(handleDailyTaskChange(...args)),
    updateDailyTaskActivity: (...args) =>
      dispatch(updateDailyTaskActivity(...args)),
    updateDailyTaskRemark: (...args) =>
      dispatch(updateDailyTaskRemark(...args)),
    updateDailyTask: (...args) => dispatch(updateDailyTask(...args)),
    deleteTaskRow: (...args) => dispatch(deleteTaskRow(...args)),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyTaskForm)
);
